import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

import {CockpitKontrolleM1} from 'shared/dtos/cockpit-kontrolle/cockpit-kontrolle';
import {EinflussVonExtremwertenM1} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m1';
import {DataStorageService} from 'shared/services/data-storage.service';
import {TableExportService} from 'shared/services/table-data-export/table-data-export.service';
import {RegressionOutputComponent} from './regression-output/regression-output.component';
import {AusreisserListeComponent} from './ausreisser-liste/ausreisser-liste.component';
import {MitarbeiterBase} from 'shared/dtos/mitarbeiterBase';
import {CockpitContentComponent} from '../../../cockpit-shared/cockpit-content-component';

@Component({
  selector: 'app-einfluss-extremwerte-m1',
  templateUrl: './einfluss-extremwerte-m1.component.html',
  styleUrl: './einfluss-extremwerte-m1.component.scss',
  standalone: false
})
export class EinflussExtremwerteM1Component
  implements OnInit, CockpitContentComponent
{
  public data: EinflussVonExtremwertenM1;
  public mitarbeiters: MitarbeiterBase[];
  card: import('shared/dtos/cockpit-card').CockpitCard;

  @ViewChild(RegressionOutputComponent, {read: ElementRef})
  regressionOutputComponent!: ElementRef;
  @ViewChild(AusreisserListeComponent, {read: ElementRef})
  ausreisserListeComponent!: ElementRef;

  constructor(
    private readonly storage: DataStorageService,
    private readonly tableExport: TableExportService
  ) {}

  async ngOnInit(): Promise<void> {
    this.data = (
      (await this.storage.getCockpitKontrolle()) as CockpitKontrolleM1
    ).einflussVonExtremwerten;
    this.mitarbeiters = await this.storage.getMitarbeiter();
  }

  exportRegressionOutput() {
    this.tableExport.exportHtmlTableInElement(
      this.regressionOutputComponent.nativeElement,
      this.card?.title
    );
  }

  exportAusreisserListe() {
    this.tableExport.exportHtmlTableInElement(
      this.ausreisserListeComponent.nativeElement,
      this.card?.title
    );
  }
}
